import { render, staticRenderFns } from "./RiskChip.vue?vue&type=template&id=9df85b24&"
import script from "./RiskChip.vue?vue&type=script&lang=js&"
export * from "./RiskChip.vue?vue&type=script&lang=js&"
import style0 from "./RiskChip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports